module.exports = __webpack_public_path__ + "img/new_logo.df1bc405.png";